import { createContext, useRef, createElement, useContext, useEffect, Children } from 'react';
import Mousetrap from 'mousetrap';

const IS_SSR = typeof Mousetrap !== 'function';
const MousetrapContext = createContext(IS_SSR ? null : Mousetrap());
function ComboKeysProvider(props) {
    const { stopAt, children } = props;
    const mousetrapRef = useRef(null);
    if (!mousetrapRef.current && !IS_SSR) {
        mousetrapRef.current = Mousetrap();
        if (stopAt) {
            const originalStopCallback = mousetrapRef.current.stopCallback;
            mousetrapRef.current.stopCallback = (e, element, combo) => originalStopCallback(e, element, combo) &&
                stopAt(e, element, combo);
        }
    }
    return (createElement(MousetrapContext.Provider, { value: mousetrapRef.current }, children));
}

function useComboKeys(keyMap) {
    const mousetrap = useContext(MousetrapContext);
    const keyMapRef = useRef(keyMap);
    keyMapRef.current = keyMap;
    const keys = Object.keys(keyMap);
    keys.sort();
    const effectKey = keys.join(';');
    useEffect(() => {
        Object.keys(keyMap).forEach(combo => {
            mousetrap.bind(combo, event => {
                keyMapRef.current[combo](event);
            });
        });
        return () => {
            Object.keys(keyMap).forEach(combo => {
                mousetrap.unbind(combo);
            });
        };
    }, [effectKey]);
}

function ComboKeys(props) {
    const { children, keyMap } = props;
    useComboKeys(keyMap);
    return children ? Children.only(children) : null;
}
function ComboKey(props) {
    const { children, combo, onTrigger } = props;
    useComboKeys({
        [combo]: onTrigger
    });
    return children ? Children.only(children) : null;
}

export { ComboKey, ComboKeys, ComboKeysProvider, useComboKeys };
